<template>
  <div>
    <base-list-management ref="baseListManagement" :configData.sync="configData" />
    <!--跟进弹窗-->
    <dialogWrap
      :dialogShow="handelDialogVisible"
      title="跟进"
      :before-close="closeDialog"
      width="450px"
    >
      <el-form :model="formData" ref="form" :rules="rules" :inline="true" label-width="100px">
        <el-form-item prop="state" label="商机状态:">
          <el-select clearable filterable v-model="formData.state" placeholder="请选择">
            <el-option
              v-for="item in BUSINESS_STATUS"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="followRecord" label="跟进记录">
          <el-input
            :rows="4"
            type="textarea"
            show-word-limit
            maxlength="500"
            v-model="formData.followRecord"
            class="follow-record-input"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <div>
          <el-button @click="closeDialog">取消</el-button>
          <el-button @click="submit" type="primary" :loading="loading">提交</el-button>
        </div>
      </template>
    </dialogWrap>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { businessManageList, businessManageFollow } from '@/api/carResource/index.js'
import { BUSINESS_STATUS, BUSINESS_STATUS_VALUE } from './const.js'
import { LEASE_TYPE_OPTIONS } from '../const.js'
import { mapGetters } from 'vuex'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  components: {},
  data() {
    return {
      BUSINESS_STATUS,
      loading: false,
      handelDialogVisible: false,
      rowData: {},
      formData: {
        state: '',
        followRecord: '',
      },
      rules: {
        state: [{ required: true, message: '请选择' }],
        followRecord: [{ required: true, message: '请输入' }],
      },
      configData: {
        isShowDepartment: false,
        formData: {
          list: [
            {
              itemConfig: {
                prop: 'brandSeriesModel',
              },
              elConfig: {
                showModel: true,
              },
              render: 'CarBrandSeriesModel',
            },
            {
              el: 'select',
              itemConfig: {
                label: '租赁类型',
                prop: 'leaseType',
              },
              elConfig: {
                clearable: true,
                placeholder: '请选择',
                options: {
                  label: 'label',
                  value: 'value',
                  list: LEASE_TYPE_OPTIONS,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '交车城市',
                prop: 'transactionCityCode',
              },
              elConfig: {
                clearable: true,
                filterable: true,
                options: {
                  label: 'city',
                  value: 'adcode',
                  list: [],
                },
              },
            },
            {
              el: 'input',
              itemConfig: {
                label: '联系人',
                prop: 'contacts',
              },
              elConfig: {
                clearable: true,
                placeholder: '请输入',
              },
            },
            {
              el: 'input',
              itemConfig: {
                label: '联系人电话',
                prop: 'mobile',
              },
              elConfig: {
                clearable: true,
                placeholder: '请输入',
              },
              directives: [{ name: 'number', arg: 'integer', value: 11 }],
            },
            {
              el: 'select',
              itemConfig: {
                label: '商机状态',
                prop: 'state',
              },
              elConfig: {
                clearable: true,
                placeholder: '请选择',
                options: {
                  label: 'label',
                  value: 'value',
                  list: BUSINESS_STATUS,
                },
              },
            },
          ],
          exportData: {
            exportTemplate: 'BusinessManageList',
            filename: '商机管理列表.xlsx',
            permissionName: 'permission_business_manage_list',
          },
          customizeReset: () => {
            this.$refs.baseListManagement.setItemData({ elConfigKey: 'disabled', key: 'seriesId', data: true })
            this.$refs.baseListManagement.setItemData({
              elConfigKey: 'value',
              key: 'brandSeriesModel',
              data: {},
            })
          },
          dealWithSearch: (params) => {
            const { brandSeriesModel } = params
            const searchParams = {
              ...params,
              brandId: brandSeriesModel.brandId,
              seriesId: brandSeriesModel.seriesId,
              modelId: brandSeriesModel.modelId,
            }
            delete searchParams.brandSeriesModel
            return searchParams
          },
        },
        tableData: {
          columns: [
            {
              name: 'id',
              columnProps: {
                prop: 'id',
                label: '商机ID',
              },
              render: ({ row }) => {
                if (!this.judgePermission('purchase_business_manage_btn_detail')) return row.id
                return <span class="a-hover-link" onClick={ () => this.handleDetailBtnClick(row)}> {row.id} </span>
              },
            },
            {
              name: 'brandName',
              columnProps: {
                prop: 'brandName',
                label: '品牌',
              },
            },
            {
              name: 'seriesName',
              columnProps: {
                prop: 'seriesName',
                label: '车系',
              },
            },
            {
              name: 'modelName',
              columnProps: {
                prop: 'modelName',
                label: '车型',
              },
            },
            {
              name: 'leaseTypeName',
              columnProps: {
                prop: 'leaseTypeName',
                label: '租赁类型',
              },
            },
            {
              name: 'transactionCityName',
              columnProps: {
                prop: 'transactionCityName',
                label: '交车城市',
              },
            },
            {
              name: 'enterpriseName',
              columnProps: {
                prop: 'enterpriseName',
                label: '企业名称',
                width: '150px',
              },
            },
            {
              name: 'contacts',
              columnProps: {
                prop: 'contacts',
                label: '联系人',
              },
            },
            {
              name: 'mobile',
              columnProps: {
                prop: 'mobile',
                label: '联系人电话',
                width: '120px',
              },
            },
            {
              name: 'leasePeriods',
              columnProps: {
                prop: 'leasePeriods',
                label: '租赁期数',
              },
            },
            {
              name: 'leaseNumber',
              columnProps: {
                prop: 'leaseNumber',
                label: '租赁数量',
              },
            },
            {
              name: 'stateName',
              columnProps: {
                prop: 'stateName',
                label: '商机状态',
              },
            },
            {
              name: 'operate',
              type: 'operate',
              columnProps: {
                label: '操作',
                fixed: 'right',
                width: 240,
              },
              maxShowLength: operateMaxShowLength,
              getOperateList: ({ row }) => {
                const btns = []
                // 跟进中、待跟进 显示跟进按钮
                if (this.judgePermission('purchase_business_manage_btn_follow') && [BUSINESS_STATUS_VALUE.FOLLOW, BUSINESS_STATUS_VALUE.ING].includes(row.state)) {
                  btns.push({
                    name: 'follow',
                    label: '跟进',
                    action: () => this.handleFollowBtnClick(row),
                  })
                }
                return btns
              },
            },
          ],
          apiFn: businessManageList,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['allCities']),
  },
  watch: {
    allCities: {
      handler(val) {
        // 交车城市枚举填充
        this.configData.formData.list.find((item) => item.itemConfig.prop === 'transactionCityCode').elConfig.options.list = val
      },
      immediate: true,
    },
  },
  methods: {
    handleDetailBtnClick(row) {
      this.$router.push({
        path: '/purchaseProvide/businessManage/detail',
        query: { id: row.id },
      })
    },
    handleFollowBtnClick(row) {
      this.rowData = row
      this.handelDialogVisible = true
    },
    closeDialog() {
      this.$refs.form.resetFields()
      this.handelDialogVisible = false
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = { id: this.rowData.id, ...this.formData }
          businessManageFollow(params).then((res) => {
            if (res?.code === 1) {
              this.$message.success('跟进成功')
              // 刷新列表
              this.$refs.baseListManagement.searchForm()
            }
          }).finally(() => {
            this.closeDialog()
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.follow-record-input {
  ::v-deep .el-textarea__inner {
    padding-bottom: 36px;
  }
}

</style>
